<template>
  <section class="policy-tab">
    <section v-show="!isEdit">
      <h3>Policy</h3>
      <div class="abs-top-right">
        <v-button
          type="primary"
          plain
          @click="handlerEdit">Edit Policy</v-button>
      </div>
      <div class="table">
        <div class="tr">
          <span>Policy Period</span>
          <span>{{ form.period }}</span>
        </div>
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ form.period_start }}</span>
        </div>
      </div>
      <div class="table">
        <div class="tr th">
          <span>Contact Person</span>
        </div>
        <div class="tr">
          <span>Name</span>
          <span>{{ form.contact_nm }}</span>
        </div>
        <div class="tr">
          <span>Phone No.</span>
          <span>{{ form.contact_phone }}</span>
        </div>
        <div class="tr">
          <span>Email</span>
          <span>{{ form.email }}</span>
        </div>
        <div class="tr">
          <span>Referral Code</span>
          <span>{{ form.code }}</span>
        </div> 
        <div class="tr">
          <span>Coupon Code</span>
          <span>{{ 
            (form.premium_data && form.premium_data.coupon_code)
              ? form.premium_data.coupon_code
              : '-'
          }}</span>
        </div> 
        <div class="tr">
          <span>Insured name</span>
          <span>{{ form.isrd_nm }}</span>
        </div> 
        <div class="tr">
          <span>Remarks</span>
          <span>{{ form.remark }}</span>
        </div>
      </div>

      <h4>Premium</h4>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Percentage</span>
          <span>Amount</span>
        </div>
        <div
          v-for="(item, index) in premiumList"
          v-show="!item.hide"
          :key="index"
          class="tr">
          <span>{{ item.label }}</span>
          <span>{{ typeof item.pct == 'number'? `${item.pct}%`: '-' }}</span>
          <span>{{ item.value | formatMoney(2, true) }}</span>
        </div>
      </div>
    </section>
    
    
    <edit-policy
      v-show="isEdit"
      ref="edit-policy"
      :type="2"
      :quoteId="form.manual_id"
      :orderId="orderId"
      :relation="form.premium_data"
      @cancel="handlerCancel"
      @save="handlerSave" />

  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
// import FileContainer from '@/views/components/file-container'
import EditPolicy from '@/views/tickets/components/add-quote'

export default {
  name: 'PolicyTab',
  components: {
    // FileContainer,
    EditPolicy
  },
  mixins: [MixinFormat],
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEdit: false   
    }
  },
  computed: {
    premiumList() {
      const premium_data = this.form.premium_data || {}
      const {
        basic_prm,
        ec_levy_vl,
        ia_levy_vl,
        premium,
        code_disc_prm,
        code_disc_pct,
        coupon_code,
        coupon_vl,
        spec_disc_prm,
        handling_fee,
        insurer_handling_fee,
        agency_handling_fee,
        amount,
        credit
      } = premium_data
      let list
      list = [
        {
          label: 'Basic Premium',
          value: basic_prm
        },
        {
          label: 'EC Levy',
          value: ec_levy_vl
        },
        {
          label: 'IA Levy',
          value: ia_levy_vl
        },
        {
          label: 'Premium',
          value: premium
        },
        {
          label: 'MGM Discount',
          pct: code_disc_pct,
          value: -code_disc_prm,
          hide: !code_disc_prm && code_disc_prm !== 0
        },
        {
          label: 'Coupon Code: ' + coupon_code,
          value: -coupon_vl,
          hide: !coupon_code
        },
        {
          label: 'Manual Discount',
          value: -spec_disc_prm
        },
        {
          label: 'Insurer Admin Charge',
          value: insurer_handling_fee
        },

        {
          label: 'Agency Admin Charge',
          value: agency_handling_fee
        },
        {
          label: 'Total Admin Charge',
          value: handling_fee
        },
        {
          label: 'Hold Dollars',
          value: credit
        },
        {
          label: 'Paid Amount',
          value: amount
        }
      ]
      return list
    }
  },
  methods: {
    handlerEdit() {
      const { 
        company_id, 
        pcy_no, 
        remark, 
        pcy_file = [] , 
        pcy_cmnt_dt = '', 
        pcy_expry_dt = '',
        insurance_type,
        isrd_nm,
        contact_nm,
        contact_phone,
        email } = this.form
      const date = [
        pcy_cmnt_dt,
        pcy_expry_dt
      ]
      this.$refs['edit-policy'].updateEditData({
        company_id,
        pcy_no,
        date,
        remark,
        insurance_type,
        isrd_nm,
        contact_nm,
        contact_phone,
        email
      })
      // console.log('kkkkkk')
      this.isEdit = true
    },
    handlerCancel() {
      this.isEdit = false
    },
    handlerSave() {
      this.isEdit = false
      this.$emit('update')
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-tab {
    position: relative;
    .table {
        margin-bottom: 40px;
    }
}
</style>